// Module
var code = "<div id=\"overlay_video\" ng-show=\"overlayVideoCtrl.displayable\" data-video=\"{{ overlayVideoCtrl.videoId }}\"> <div class=\"overlay_video_close_btn\" ng-click=\"overlayVideoCtrl.closeOverlay()\"></div> <div id=\"player\"/> </div> ";
// Exports
module.exports = code;